import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from "gsap/CustomEase";
import Swiper from 'swiper/bundle';


/*-------------------------------------
 スクロール時の処理
--------------------------------------*/
let startPos = 0;
let winScrollTop = 0;
let threshold = window.innerHeight * 0.5;
const topSliderEl = document.getElementById('topSlider');

window.addEventListener('scroll', () => {
  winScrollTop = window.scrollY;

  if (topSliderEl) {
    const topSliderHeight = topSliderEl.offsetHeight;
    if (winScrollTop >= topSliderHeight) {
      document.body.classList.add('is-scroll-toppage');
    } else {
      document.body.classList.remove('is-scroll-toppage');
    }
  } else {
    document.body.classList.remove('is-scroll-toppage');
  }

  if (winScrollTop !== 0) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }

  if (winScrollTop >= startPos) {
    if (winScrollTop >= threshold) {
      document.body.classList.add('is-down');
    }
  } else {
    document.body.classList.remove('is-down');
  }
  startPos = winScrollTop;
});
window.addEventListener('resize', () => {
  threshold = window.innerHeight;
});

/*-------------------------------------
 GSAP ScrollTrigger
--------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

function createScrollTrigger(selector, start, className, markers = false, pin = false) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: start,
      toggleClass: { targets: el, className: className },
      once: true,
      markers: markers,
			pin: pin,
    });
  });
}

/*-------------------------------------
 Swiper（787px未満のみ）
--------------------------------------*/
const SWIPER_BREAKPOINT = 787;
let swiper = null;

function initSwiper() {
  if (swiper) return;

  swiper = new Swiper('.swiper', {
    pagination: {
      el: '.swiper-pagination',
    },
  });
}

function destroySwiper() {
  if (!swiper) return;

  swiper.destroy(true, true);
  swiper = null;
}

function handleSwiper() {
  if (window.innerWidth >= SWIPER_BREAKPOINT) {
    destroySwiper();
  } else {
    initSwiper();
  }
}

/*-------------------------------------
 メニュー開閉・トグル関連
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  createScrollTrigger('.fadeUp','top 75%','is-active');
  document.body.classList.add('is-ready');

  // リサイズ対応
  function handleResize() {
    if (window.innerWidth >= 768) {
      document.body.classList.remove('fixed');
      document.body.style.top = '0';
    }
  }
  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);

  handleSwiper();
  window.addEventListener('resize', handleSwiper);
});

document.addEventListener('DOMContentLoaded', async () => {
  const faqElements = document.querySelector('#faq');
  if (faqElements) {
    const questions = faqElements.querySelectorAll('.unit');
    questions.forEach(question => {
      const q = question.querySelector('.q');
      question.addEventListener('click', () => {
        question.classList.toggle('is-active');
        const nextElement = q.nextElementSibling;
        if (nextElement.style.display === 'none' || !nextElement.style.display) {
          nextElement.style.display = 'block';
        } else {
          nextElement.style.display = 'none';
        }
      });
    });
  }
  
});